import { get } from 'Utils/common';
import { INVESTMENT_STEPS, INVESTMENT_STEPS_CONST, INVESTMENT_STEP_BY_STATUS } from 'Config/constans';
import INVESTMENT_CONST from 'Const/investment.json';

const { INVESTMENT_STATUS, PROFILE_TYPES, SIGNATURE_DOCUMENTS } = INVESTMENT_CONST;

export default {
  investmentData: state => state.investmentData,
  investmentDataLoading: state => state.investmentDataLoading,
  investmentDataLoaded: state => state.investmentDataLoaded,
  investmentProfileList: (state, getters, rootState) => rootState.account.accountList,
  investmentList: state => state.investmentList,
  investmentListLoading: state => state.investmentListLoading,
  investmentListLoaded: state => state.investmentListLoaded,
  // Filter pending investment list to exclude canceled by manager
  investmentListPending: state => state.investmentList.filter(item => item.status !== INVESTMENT_STATUS.CANCELED_BY_MANAGER),
  investmentListCompleted: state => (
    state.investmentList.filter(item => item.status === INVESTMENT_STATUS.COMPLETED)
  ),
  investmentListCompletedSuccessful: state => state.investmentListCompletedSuccessful,
  investmentListCompletedSuccessfulLoading: state => state.investmentListCompletedSuccessfulLoading,

  createModel: state => state.createModel,
  stepModels: state => state.stepModels,
  shareNumber: state => (
    (state.stepModels.amount && state.stepModels.amount.number_of_shares)
    || state.createModel.number_of_shares
  ),
  sharePrice: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.price_per_share;
  },
  unitPrice: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.raised / farmData.units;
  },
  isUnitType: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.isUnitType;
  },
  isUnitOfferingType: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.isInvestUnitType;
  },
  amount: (state, getters) => {
    if (getters.isUnitType) {
      return getters.shareNumber * getters.unitPrice;
    }
    return getters.shareNumber * getters.sharePrice;
  },
  acresNumber: (state, getters) => (getters.shareNumber / 10) || 0,
  /**
   * Which is max step you can go on refresh
   * by investment process status loaded from api
   * @param state
   * @returns {number}
   */
  maxStepIndexByStatus: (state) => {
    const statusNumber = state.investmentData.status;
    const step = INVESTMENT_STEP_BY_STATUS[statusNumber];
    if (!step) return -1;
    return INVESTMENT_STEPS.findIndex(stepItem => stepItem.value === step);
  },
  sharesOrUnits: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.getAssetTypeTitlePlural(2);
  },
  selectedProfileId: (state, getters) => get(
    getters.stepModels,
    'ownership.$serverData.profile_id',
    state.selectedProfileId,
  ),
  selectedProfile: (state, getters) => (
    getters.investmentProfileList.find(item => item.id === getters.selectedProfileId)
  ),
  investmentIsSdira: (state, getters) => (
    Boolean(getters.selectedProfile && getters.selectedProfile.type === PROFILE_TYPES.SDIRA)
  ),
  investmentIsEntity: (state, getters) => (
    Boolean(getters.selectedProfile && getters.selectedProfile.type === PROFILE_TYPES.ENTITY)
  ),
  investmentIsSignatureComplete: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.SIGNATURES];
    if (!model) return false;
    return !model.$v.$invalid;
  },
  investmentIsFundingComplete: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.FUNDING];
    if (!model) return false;
    return Boolean(model.$serverData && model.$serverData.funding_source);
  },
  investmentIsAccreditationComplete: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.ACCREDITATION];
    if (!model) return false;
    return model.$sendSuccess;
  },
  // Is reset signature needed in case when it required
  investmentIsSignatureResetNeeded: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.SIGNATURES];
    if (!model) return false;
    return getters.investmentIsSignatureComplete
      || model.$serverData.checkboxes
      || SIGNATURE_DOCUMENTS.some(doc => model.$serverData[doc.name]);
  },
  selectedProfileAccreditedDays: (state, getters) => (
    (getters.selectedProfile || {}).accreditation_type === 'income' ? 365 : 90
  ),
  reInitiateTransactionInvestmentListItemLoading: state => state.reInitiateTransactionInvestmentListItemLoading,
  investmentSingleData: state => state.investmentSingleData,
  investmentSingleDataLoading: state => state.investmentSingleDataLoading,
  investmentIsFinished: (state, getters) => (
    getters.investmentList.some(item => String(item.id) === String(getters.investmentData.id))
  ),
  investmentListOpenSummary: state => state.investmentListOpenSummary,
  investmentListCompletedSummary: state => state.investmentListCompletedSummary,
  investmentListCompletedSuccessfulLoaded: state => state.investmentListCompletedSuccessfulLoaded,

  investmentsDocuments: state => state.investmentsDocuments || [],
  investmentsDocumentsLoading: state => state.investmentsDocumentsLoading,
  investmentsDocumentsLoaded: state => state.investmentsDocumentsLoaded,

  investmentsDocumentsUpdatesList: (state) => {
    const filtered = state.investmentsDocuments.length
      ? state.investmentsDocuments
        .filter(item => item.update_documents_folder.length > 0)
      : [];
    return filtered;
  },
  investmentsDocumentsTaxList: (state, getters) => {
    const filtered = getters.investmentsDocuments.length
      ? getters.investmentsDocuments
        .filter(item => item.tax_documents.length > 0)
      : [];
    return filtered;
  },
  investmentListCounts: state => state.investmentListCounts || {},
  investmentListCountsOpen: (state, getters) => getters.investmentListCounts?.funding || 0,
  investmentListCountsClosed: (state, getters) => getters.investmentListCounts?.active || 0,
  investmentListCountsExited: (state, getters) => getters.investmentListCounts?.exited || 0,
  isSomeInvestment: (state, getters) => (getters.investmentListCountsOpen
    || getters.investmentListCountsClosed
    || getters.investmentListCountsExited)
    > 0,
};
